export const LANDING_LOC_TEXTS = {
  us: 'Launching Roland Cloud Manager',
  mx: 'Iniciando Roland Cloud Manager',
  no: 'Lanserer Roland Cloud Manager',
  se: 'Lanserar Roland Cloud Manager',
  dk: 'Lancering af Roland Cloud Manager',
  fi: 'Käynnistämme Roland Cloud Managerin',
  nl: 'Roland Cloud Manager starten',
  de: 'Starten von Roland Cloud Manager',
  fr: 'Lancement de Roland Cloud Manager',
  it: 'Avvio di Roland Cloud Manager',
  br: 'Lançamento do Roland Cloud Manager',
  ru: 'Запуск Roland Cloud Manager',
  ro: 'Lansarea Roland Cloud Manager',
  sk: 'Spustenie Roland Cloud Manager',
  cz: 'Spuštění Roland Cloud Manager',
  hu: 'A Roland Cloud Manager elindítása',
  pl: 'Uruchamianie Roland Cloud Manager',
  jp: 'Roland Cloud Managerを起動しています',
};
